import React from 'react'
import styled from "styled-components";
import { useGlobalContext } from "../useContext";
import {motion} from "framer-motion";

function Sidebar() {
  const { isSidebar, setSidebar } = useGlobalContext();

  const [scroll, setScroll] = React.useState(0);

  React.useEffect(() => {
    document.addEventListener("scroll", () => {
      const scrollCheck = window.scrollY > 0;
      if (scrollCheck !== scroll) {
        setScroll(scrollCheck);
      }
    });
  });

  //for the links
  const handleClick = (e, id) => {
    e.preventDefault();
    e.stopPropagation(); // Nu bloca alte evenimente
    window.location.hash = id;
    const element = document.getElementById(id);
    console.log(element);
    const y = element.getBoundingClientRect().top + window.pageYOffset;

    window.scrollTo({ top: y - 10, behavior: "smooth" }); // Aplicăm offset-ul de înălțime aici
    element.style.color="#847dff";
    setSidebar(false);
  };

  return (
    <Wrapper
      className={`
        ${!isSidebar ? "sidebar" : "open section__center"}`}
    >
      <div className="links__container">
       <div>
       <motion.a href="#experience"
       initial={{x: "100vh"}}
       animate={isSidebar ? { x: 0 } : { x: "100vw" }} 
       transition={{duration: 0.3, ease: "easeInOut"}}
        onClick={(e) => handleClick(e, "experience")}>
          Experience
        </motion.a>
       </div>

        <div>
        <motion.a href="#projects" 
        initial={{x: "-100vw"}}
        animate={isSidebar ? { x: 0 } : { x: "-100vw" }} 
       transition={{duration: 0.3, ease: "easeInOut"}}
        onClick={(e) => handleClick(e, "projects")}>
          Projects
        </motion.a>
        </div>
        
       <div>
       <motion.a href="#contact"
       initial={{x: "100vw"}}
       animate={isSidebar ? { x: 0 } : { x: "100vw" }} 
       transition={{duration: 0.3, ease: "easeInOut"}}
       onClick={(e) => handleClick(e, "contact")}>
          Contact
        </motion.a>
       </div>

       <div>
       <motion.a href="https://mihaelas-blog.onrender.com/" target="_blank"
       initial={{x: "-100vw"}}
       animate={isSidebar ? { x: 0 } : { x: "-100vw" }} 
       transition={{duration: 0.3, ease: "easeInOut"}}>
          News & Blogs
        </motion.a>
       </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  &.sidebar {
    height: calc(100vh - 5rem);
  width: 100%;
  padding: 8rem 3rem;
  z-index: 5000;
  position: fixed;
  top: calc(-100% - 5rem);
  transition: all 0.3s ease;
  }

  &.open {
    height: calc(100vh - 5rem);
    width: 100%;
    padding: 8rem 3rem;
    position: fixed;
    top: 5rem;
    left: 0;
    z-index: 5000;
    background: var(--clr-navy-7);
    pointer-events: auto;
    transition: all 0.3s ease;
  }

  .links__container {
    width: max-content;
    margin: 0 auto;
    margin-top: -3.5rem;
    display: flex;
    flex-direction: column;
  }

  a {
    display: block;
    margin-bottom: 3.5rem;
    font-size: 1.1rem;
    letter-spacing: 0.08rem;
    text-align: center;
    color: var(--clr-grey-8);
    position: relative;
    pointer-events: auto;
    position: relative;
    z-index: 5000;
    white-space: nowrap;
    transition: all 0.5s;
  }

  @keyframes animationColor {
    0% {
      color: hsl(210, 31%, 80%);

    }
    25% {
      color: #847dff;
    }
    50% {
      color: #f52c57;
    }
    80% {
      color: #00CCFF;
    }
    100% {
      color: #BA55D3;
    }
  }

  a:hover {
    transform: scale(1.2) !important;
    opacity: 1;
    filter: blur(0);
    border-radius: 0.3rem;
  }

  @media screen and (min-width: 992px) {
    .sidebar {
      display: none;
    }
  }
`;

export default Sidebar;

